// extracted by mini-css-extract-plugin
export default {"wrapper":"SliderBlock_wrapper__F-g+F"};